import { Link } from '@tanstack/react-router';
import { CheckCircle2, Circle } from 'lucide-react';
import { kr } from '../../lib/money';
import type { RouterOutputs } from '../../lib/trpc';
import { Panel } from '../common/Panel';

type Summary = RouterOutputs['period']['summary'];

/** Bills and loans still to be paid this period (already counted in the hero). */
export function UpcomingCard({ summary }: { summary: Summary }) {
  const { items, unpaid } = summary.fixedCosts;
  if (items.length === 0) return null;
  const open = items.filter((f) => !f.isPaid);
  const paidCount = items.length - open.length;

  return (
    <Panel
      title="Kvar att betala"
      action={
        <Link
          to="/plan"
          search={{ year: summary.period.year, month: summary.period.month }}
          className="font-medium text-primary hover:underline"
        >
          Alla fasta
        </Link>
      }
    >
      {open.length === 0 ? (
        <p className="flex items-center gap-2 text-sm text-muted-foreground">
          <CheckCircle2 className="size-4 text-positive" />
          Alla {items.length} fasta kostnader är betalda.
        </p>
      ) : (
        <>
          <ul className="-my-1">
            {open.map((f) => (
              <li
                key={`${f.kind}-${f.id}`}
                className="flex items-center gap-3 border-b border-border/60 py-2.5 text-sm last:border-0"
              >
                <Circle className="size-4 shrink-0 text-muted-foreground" aria-hidden />
                <span className="min-w-0 flex-1 truncate">{f.name}</span>
                <span className="tabular-nums">{kr(f.expected)}</span>
              </li>
            ))}
          </ul>
          <div className="mt-2 flex justify-between border-t border-border pt-2.5 text-sm">
            <span className="text-muted-foreground">
              {paidCount > 0 ? `${paidCount} av ${items.length} betalda` : 'Inget betalt än'}
            </span>
            <span className="font-semibold tabular-nums">{kr(unpaid)}</span>
          </div>
        </>
      )}
    </Panel>
  );
}
